import * as React from 'react';
import tombacIcon from '../tombacIcon';

function SvgUnmapped(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="6 -4 12 24" {...props}>
      <path
        d="M13 13v3h-3v-3zm-.775-13c3.306 0 5.653 1.847 5.77 4.472l.005.251c0 2.588-2.28 4.224-5.273 4.722L12.485 12h-1.946l-.39-4.014a.578.578 0 01.193-.485l.07-.065a.566.566 0 01.265-.13l.1-.01c2.629-.055 4.188-.928 4.281-2.354l.005-.198c0-1.314-1.137-2.274-2.884-2.274-1.472 0-2.678.589-3.858 1.826l-.367.384L6 2.98l.314-.345C7.903.893 9.753 0 12.224 0z"
        fill="currentColor"
      />
    </svg>
  );
}

export default tombacIcon('Unmapped')(SvgUnmapped);
